import { render, staticRenderFns } from "./RideCopyOffer.vue?vue&type=template&id=632185e9"
import script from "./RideCopyOffer.vue?vue&type=script&lang=js"
export * from "./RideCopyOffer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports